import { connect } from 'react-redux';
import MonthlyFixedInputs from './MonthlyFixedInputs';

import { setMonthlyFixedInputs } from '../../../common/utility/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    mFixedCharge: state.utility.mFixedCharge,
    setMonthlyFixedInputs,
});

const combinedActions = {
    setMonthlyFixedInputs,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(MonthlyFixedInputs);



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/MonthlyFixedInputs/index.js